import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

function CircularLoading({ ...props }) {
    return (
        <CircularProgress {...props} />
    );
}

export default CircularLoading;